export const gitCommit = '9c0f4df0'
